import { render } from "./InputMathDlg.vue?vue&type=template&id=5dd5a3a6&scoped=true"
import script from "./InputMathDlg.vue?vue&type=script&lang=js"
export * from "./InputMathDlg.vue?vue&type=script&lang=js"

import "./InputMathDlg.vue?vue&type=style&index=0&id=5dd5a3a6&lang=scss&scoped=true"

import exportComponent from "/Users/alexeysorokin/Desktop/hexp2/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dd5a3a6"]])

export default __exports__